module.exports = __webpack_public_path__ + "img/new_09.a9bcfa1f.jpg";